export default __webpack_public_path__ + "static/media/wiki-olympus-desktop.9dc4ee27.jpg";